// @flow
import CSSTransition from 'react-transition-group/CSSTransition';
import generalIcons from '~/core/constants/icons/general-svg';
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const Wrapper = styled.div`
    border: 1px ${props => props.theme.lightGrey} solid;
    border-radius: 32px;
    display: flex;
    height: 3.8em;
`;

export const ArrowWrapper = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    width: 3.8em;
    z-index: 10;
`;

export const ArrowLeft = styled(SVGIcon).attrs({ type: generalIcons.ARROW_LEFT })`
    height: 1.5em;
    width: 1.5em;

    & g {
        fill: ${props => props.theme.mainBrandColor};
    }
`;

export const ArrowRight = ArrowLeft.extend.attrs({ type: generalIcons.ARROW_RIGHT })``;

export const Content = styled.div`
    flex: 1;
    position: relative;
`;

export const ItemWrapper = styled.div`padding-top: 0.5em;`;

export const StyledCSSTransition = styled(CSSTransition)`
    &.mode-selector-slide-left-enter,
    &.mode-selector-slide-right-enter {
        bottom: 0;
        left: 0;
        opacity: 0.01;
        position: absolute;
        right: 0;
        top: 0;
    }
    &.mode-selector-slide-left-enter {
        transform: translateX(20%);
    }

    &.mode-selector-slide-right-enter {
        transform: translateX(-20%);
    }

    &.mode-selector-slide-left-enter.mode-selector-slide-left-enter-active,
    &.mode-selector-slide-right-enter.mode-selector-slide-right-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 300ms ease-in 150ms, transform 300ms ease-in 150ms;
    }

    &.mode-selector-slide-left-exit,
    &.mode-selector-slide-right-exit {
        bottom: 0;
        left: 0;
        opacity: 1;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(0);
    }

    &.mode-selector-slide-left-exit.mode-selector-slide-left-exit-active,
    &.mode-selector-slide-right-exit.mode-selector-slide-right-exit-active {
        opacity: 0.01;
        transition: opacity 300ms ease-in, transform 300ms ease-in;
    }

    &.mode-selector-slide-left-exit.mode-selector-slide-left-exit-active {
        transform: translateX(-20%);
    }

    &.mode-selector-slide-right-exit.mode-selector-slide-right-exit-active {
        transform: translateX(20%);
    }
`;

export const ModeName = styled.span`
    display: block;
    font-size: ${props => (props.hasDescription ? '1em' : '1.2em')};
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    margin-top: ${props => (props.hasDescription ? 0 : '0.65em')};
    white-space: nowrap;
`;

export const Description = styled.span`
    color: ${props => props.theme.mediumGrey};
    display: block;
    font-size: 0.9em;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const PaginationContainer = styled.div`
    bottom: 0.2em;
    left: 0;
    position: absolute;
    right: 0;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-slide/styles.js